import { Box } from '@bechtel/gds';
import { FC, PropsWithChildren } from 'react';
import { MoreOptionsItem } from '../nav-more-options';
import { NavbarItems } from './items';
import { CopyRightsContent } from './items/copy-rights';
import { ContainerStyled } from './styled';

interface NavbarProps {
  showMore?: React.Dispatch<React.SetStateAction<boolean>>;
  navbarItems: MoreOptionsItem[];
}

export const Navbar: FC<PropsWithChildren<NavbarProps>> = ({ showMore, navbarItems, children }) => {
  return (
    <ContainerStyled>
      <Box flexGrow={{ sm: '1' }}>
        {children}
        <NavbarItems items={navbarItems} showMore={showMore} />
      </Box>
      <CopyRightsContent />
    </ContainerStyled>
  );
};
